import React, { useState } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { COLORS, GRADIENTS } from './themeConstants';
import { HiChevronLeft, HiChevronRight } from 'react-icons/hi';
import { BsBuilding } from 'react-icons/bs';

export const clients = [
	{
		_id: 'COL-BB271658898E-4DE0-BC30-B58B89594F80',
		collegeName: 'MOULANA COLLEGE OF ARTS, SCIENCE AND COMMERCE',
		logo: 'https://firebasestorage.googleapis.com/v0/b/necttos-production.appspot.com/o/colleges%2F60e721a23da25dd3d5de34b0%2Flogo.png?alt=media&token=cac85ecf-5efe-40f1-a5a8-a3c45c5825b0',
		address: ' Chennara,Tirur, Malappuram, Kerala, India',
		createdOn: {
			$date: '2021-08-03T05:44:33.620Z',
		},
		isApproved: true,
		status: 'approved',
		institutionType: 'affiliated',
	},

	{
		_id: 'COL-BB2631888FF3-4B9E-8DD2-59FF3CA88846',
		collegeName: 'AMC GROUP OF EDUCATIONAL INSTITUTIONS',
		logo: 'https://firebasestorage.googleapis.com/v0/b/necttos-production.appspot.com/o/colleges%2F60e721a23da25dd3d5de343a%2Flogo.png?alt=media&token=89d2dc7e-79bb-4abc-98ae-8bd6ac68dc1f',
		address: 'AMC Building, Kothayur Road, Manissery P.O., Ottapalam,',
		isApproved: true,
		status: 'approved',
		createdOn: {
			$date: '2021-08-02T10:50:37.434Z',
		},
		institutionType: 'affiliated',
	},
	{
		_id: 'COL-A611B639AA92-4288-81DB-BA777E497A59',
		collegeName: 'M.P.MOOTHEDATH MEMORIAL SREE NARAYANA TRUSTS COLLEGE',
		logo: 'https://firebasestorage.googleapis.com/v0/b/necttos-production.appspot.com/o/colleges%2F6113f2f9dd1facf556084856%2Fsn%20logo.png?alt=media&token=113c1dea-df18-43fb-842b-afd1ac1d6eb3',
		address: 'SHORANUR-II, PALAKKAD - 679122',
		isApproved: true,
		status: 'approved',
		createdOn: {
			$date: '2021-09-03T08:55:43.470Z',
		},
		institutionType: 'affiliated',
	},
	{
		_id: 'COL-9E8AF41AB347-4BD6-8A1D-43D02D39738E',
		collegeName: 'T.K. Madhava Memorial College',
		logo: 'https://firebasestorage.googleapis.com/v0/b/necttos-production.appspot.com/o/principalSignature%2FfoundedData.jpg?alt=media&token=0c23b760-5836-4b99-823a-e866c5506bfd',
		address: 'Alappuzha, Kerala , India, Pin : 690513',
		isApproved: true,
		status: 'pending',
		createdOn: {
			$date: '2022-02-17T10:29:39.009Z',
		},
		institutionType: 'affiliated',
	},

	{
		_id: 'COL-D209492D4FB7-4E07-848E-A317A1BC9196',
		collegeName: "ST.MARY'S COLLEGE, SULTHAN BATHERY (Aided)",
		logo: 'https://firebasestorage.googleapis.com/v0/b/necttos-production.appspot.com/o/colleges%2F6113f2f9dd1facf5560848e1%2Flogo.png?alt=media&token=a92cd2a1-bc2b-43a6-9a57-1a6fad012cd4',
		address: "St. Mary's College, Sulthan Bathery",
		isApproved: true,
		status: 'approved',
		createdOn: {
			$date: '2022-07-14T14:14:11.169Z',
		},
		institutionType: 'affiliated',
	},
	{
		_id: 'COL-3FAA19D25E23-4558-AE0C-D89C4D37D418',
		collegeName: 'ST MARYS COLLEGE, SULTHAN BATHERY (Self)',
		logo: 'https://firebasestorage.googleapis.com/v0/b/necttos-production.appspot.com/o/colleges%2F6113f2f9dd1facf5560848e1%2Flogo.png?alt=media&token=338c4f9f-2970-499c-9332-aab19658560f',
		address: 'Sulthan Batheri',
		isApproved: true,
		status: 'approved',
		createdOn: {
			$date: '2022-08-06T18:45:37.390Z',
		},
		institutionType: 'affiliated',
	},

	{
		_id: 'COL-E67980529419-4EFA-BAF8-ABD89D79284D',
		collegeName: 'St. Gregorios College, Kottarakkara',
		logo: 'https://firebasestorage.googleapis.com/v0/b/necttos-production.appspot.com/o/colleges%2FCOL-SDFGHJK-345678-POKNBFR-12345%2Flogo.png?alt=media&token=5d397517-d5c2-4215-b593-f8bbfcd1a748',
		address: 'Pulamon P.o, Kottarakkara - 691531',
		createdOn: {
			$date: '2022-12-07T05:26:24.610Z',
		},
		isApproved: true,
		status: 'approved',
		institutionType: 'affiliated',
	},
	{
		_id: 'COL-5F9623C234F8-45AA-A2A3-C5F5734E1F77',
		collegeName: 'SREE NARAYANA COLLEGE CHERTHALA',
		logo: 'https://firebasestorage.googleapis.com/v0/b/necttos-production.appspot.com/o/colleges%2FCOL-SDFGHJK-345678-345EHIHJN-12345%2Flogo.png?alt=media&token=4921e7ec-586c-4e1b-97b1-7f10c9765955',
		address: 'S.N Puram P.O,Cherthala',
		isApproved: true,
		status: 'approved',
		createdOn: {
			$date: '2023-01-23T16:48:22.004Z',
		},
		institutionType: 'affiliated',
	},
	{
		_id: 'COL-4E56593776BE-41C3-982A-0B6DC20E44A0',
		collegeName: 'GOVT. VICTORIA COLLEGE, PALAKKAD',
		logo: 'https://firebasestorage.googleapis.com/v0/b/necttos-production.appspot.com/o/blue%20EMBLEM.png?alt=media&token=48d0b06f-a046-454a-b107-40a23a5e65b3',
		address: 'PALAKKAD, KERALA, INDIA - 678001',
		isApproved: {
			library: true,
			department: true,
			office: true,
		},
		status: 'approved',
		createdOn: {
			$date: '2023-03-31T11:13:39.005Z',
		},
		institutionType: 'affiliated',
	},
	{
		_id: 'COL-32A6A87924CF-41FE-A825-843CC7A155B4',
		collegeName: 'ST Thomas College Ranni',
		logo: 'https://firebasestorage.googleapis.com/v0/b/necttos-production.appspot.com/o/colleges%2F6113f2f9dd1facf5560848e2%2Flogo.png?alt=media&token=1d373926-99a4-4005-9190-7b762ffcbab2',
		address: 'Ranni, Pathanamthitta',
		isApproved: true,
		status: 'approved',
		createdOn: {
			$date: '2022-11-04T10:12:24.993Z',
		},
		institutionType: 'affiliated',
	},
	{
		_id: 'COL-4BE8C5548D0C-432E-AA07-1D5DE104B3C6',
		collegeName: 'SACRED HEART COLLEGE FOR WOMEN, CHALAKUDY',
		logo: 'https://firebasestorage.googleapis.com/v0/b/necttos-production.appspot.com/o/colleges%2F6113f2f9dd1facf5560848ac%2Flogo.png?alt=media&token=a88c068b-0dcc-45c7-b02c-17d659753fe6',
		address: 'Chalakudy',
		isApproved: true,
		status: 'approved',
		createdOn: {
			$date: '2023-06-23T09:37:56.860Z',
		},
		institutionType: 'affiliated',
	},
	{
		_id: 'COL-85A6CCA7E82D-48CF-A333-8D3DF7F88E32',
		collegeName: "St. Cyril's College Adoor",
		logo: 'https://firebasestorage.googleapis.com/v0/b/necttos-production.appspot.com/o/IMG_5946.jpg?alt=media&token=60ef4616-06f9-4354-9ed1-0363c3019cff',
		address: 'St. Cyril’s College, Cyrils mount, Vadakkedathkavu P O,  Kilivayal, Adoor',
		createdOn: {
			$date: '2023-07-06T12:43:02.991Z',
		},
		isApproved: true,
		status: 'approved',
		institutionType: 'affiliated',
	},

	{
		_id: 'COL-AF7BBD488D81-439A-BC17-53A7FC0DC496',
		collegeName: "ST. DOMINIC'S COLLEGE, KANJIRAPALLY",
		logo: 'https://firebasestorage.googleapis.com/v0/b/necttos-production.appspot.com/o/Screenshot%202024-06-14%20at%202.34.15%20PM.png?alt=media&token=e90e832d-ee07-4d98-989c-4c078c26081b',
		address: 'Parathode PO, Kanjirapally 686512',
		isApproved: true,
		status: 'aproved',
		createdOn: {
			$date: '2024-06-14T05:13:15.244Z',
		},
		institutionType: 'affiliated',
	},
	{
		_id: 'COL-D4F1E2B6FCE5-457C-AB5D-3D0F80462CF0',
		collegeName: 'WMO ARTS AND SCIENCE COLLEGE MUTTIL',
		logo: 'https://firebasestorage.googleapis.com/v0/b/necttos-production.appspot.com/o/Screenshot%202024-06-14%20at%2011.08.12%20PM.png?alt=media&token=6ae1441b-1259-43b8-8332-c00307ea73bf',
		address: 'Muttil Po, Kalpetta, Wayanad',
		isApproved: true,
		status: 'aproved',
		createdOn: {
			$date: '2024-06-14T17:27:57.013Z',
		},
		institutionType: 'affiliated',
	},

	{
		_id: 'COL-6884F516130D-4816-BCE7-1909863D4DBC',
		collegeName: 'NMSM GOVERNMENT COLLEGE, KALPETTA',
		logo: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTanndDnayO1n0Oxs9AMdkQizlskmDeYek3UxLdws2k-uftYKApOE577us25CqxB48qOHE&usqp=CAU',
		address: 'Puzhamudi.P.O, Kalpetta Wayanad Dt, Kerala, INDIA',
		isApproved: true,
		status: 'approved',
		createdOn: {
			$date: '2024-08-24T08:23:46.249Z',
		},
	},
];

const CustomArrow = ({ onClick, direction }) => (
	<button
		onClick={onClick}
		className={`
		absolute top-1/2 transform -translate-y-1/2 z-10
		p-3 rounded-full transition-all duration-300
		${COLORS.background.primary}
		${COLORS.text.primary}
		hover:${COLORS.background.secondary}
		focus:outline-none focus:ring-2
		${COLORS.border.focus}
		${direction === 'left' ? 'left-2 md:left-4' : 'right-2 md:right-4'}
	  `}
		aria-label={`${direction === 'left' ? 'Previous' : 'Next'} slide`}>
		{direction === 'left' ? <HiChevronLeft className='w-6 h-6' /> : <HiChevronRight className='w-6 h-6' />}
	</button>
);

// -- Specific Arrow Wrappers
const NextArrow = (props) => <CustomArrow {...props} direction='right' />;
const PrevArrow = (props) => <CustomArrow {...props} direction='left' />;

// -- Single Client Card
const ClientCard = ({ client }) => {
	const [isHovered, setIsHovered] = useState(false);
	const [imageError, setImageError] = useState(false);

	return (
		<div className='px-4 h-full hover:scale-105 duration-200' onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>
			<div
				className={`
			relative flex flex-col items-center justify-center 
			p-6 my-6 rounded-lg
			${COLORS.background.glass} backdrop-blur-sm 
			${COLORS.border.secondary} border
			${COLORS.shadow.primary}
			transition-all duration-300 hover:shadow-xl 
			h-64 group
		  `}>
				{/* Logo container */}
				<div
					className={`
			  relative h-32 w-32 rounded-full p-3 mb-4
			  ${COLORS.background.secondary}
			  transition-transform duration-300
			  group-hover:scale-105
			`}>
					{!imageError && client.logo ? (
						<img src={client.logo} alt={`${client.collegeName} Logo`} className='h-full w-full object-contain rounded-full' loading='lazy' onError={() => setImageError(true)} />
					) : (
						<div className='h-full w-full flex items-center justify-center rounded-full bg-gray-700'>
							<BsBuilding className='w-12 h-12 text-gray-400' />
						</div>
					)}
				</div>

				{/* Institution details */}
				<div
					className={`
			  text-center transition-opacity duration-300 
			  ${isHovered ? 'opacity-100' : 'opacity-90'}
			  z-10
			`}>
					<h3
						className={`
				text-lg font-medium line-clamp-2 mb-2
				${COLORS.text.primary}
			  `}>
						{client.collegeName}
					</h3>
					{isHovered && (
						<p
							className={`
				  text-sm line-clamp-2 transition-all duration-300
				  ${COLORS.text.secondary}
				`}>
							{client.address}
						</p>
					)}
				</div>

				{/* Hover overlay */}
				<div
					className={`
			  absolute inset-0 rounded-lg
			  ${GRADIENTS.background.overlay}
			  opacity-0 transition-opacity duration-300
			  group-hover:opacity-30
			`}
				/>
			</div>
		</div>
	);
};

// -- Main ClientsSection Component
const ClientsSection = () => {
	// Filter and sort clients
	const validClients = clients.filter((client) => client.status?.toLowerCase() === 'approved').sort((a, b) => a.collegeName.localeCompare(b.collegeName));

	// Slider settings
	const settings = {
		dots: true,
		infinite: true,
		speed: 1500,
		slidesToShow: 4,
		slidesToScroll: 2,
		autoplay: true,
		autoplaySpeed: 3000,
		pauseOnHover: true,
		arrows: true,
		nextArrow: <NextArrow />,
		prevArrow: <PrevArrow />,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1,
					infinite: true,
					dots: true,
				},
			},
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
					initialSlide: 2,
				},
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			},
		],
	};

	return (
		<section
			id='clients'
			className={`
		  py-16 relative overflow-hidden 
		  bg-gradient-to-br 
		  ${GRADIENTS.background.primary}
		`}
			aria-label='Our Partner Institutions'>
			<div className='container mx-auto px-4'>
				{/* Section Title */}
				<h2
					className={`
			  text-4xl font-bold text-center mb-12 
			  bg-gradient-to-r ${GRADIENTS.text.accent} 
			  bg-clip-text text-transparent
			`}>
					Our Partner Institutions
				</h2>

				<div className='relative'>
					{/* Slider Container */}
					<div
						className={`
				-mx-4 relative
				${COLORS.background.glass}
				backdrop-blur-sm rounded-xl p-4
			  `}>
						<Slider {...settings}>
							{validClients.map((client) => (
								<ClientCard key={client._id} client={client} />
							))}
						</Slider>
					</div>

					{/* Decorative Elements */}
					<div
						className={`
				absolute -top-10 -right-10 h-32 w-32 rounded-full
				bg-gradient-to-br ${GRADIENTS.background.accent}
				opacity-20 blur-xl
			  `}
					/>
					<div
						className={`
				absolute -bottom-10 -left-10 h-32 w-32 rounded-full
				bg-gradient-to-br ${GRADIENTS.background.secondary}
				opacity-20 blur-xl
			  `}
					/>
				</div>
			</div>

			<style jsx='true' global='true'>{`
				.slick-dots li button:before {
					display: none;
				}
				.slick-dots li.slick-active button {
					background-color: #3b82f6;
					width: 1.5rem;
					border-radius: 0.25rem;
				}
			`}</style>
		</section>
	);
};

export default ClientsSection;
